import React from 'react'
import { CurrencyFormat } from '../../../helpers/formatting'
import { sortData, handleSort } from './chirpResultsHelpers'
import SortableColumnHeader from './SortableColumnHeader'
import CollapsibleTableSection from './CollapsibleTableSection'

const COLUMNS = [
  { column: 'category', label: 'Category' },
  { column: 'totalCount', label: 'Total Count' },
  { column: 'totalAmount', label: 'Total Amount' },
  { column: 'recentCount', label: 'Recent Count' },
  { column: 'recentAmount', label: 'Recent Amount' },
]

const TransactionAnalysisTable = ({ data, expanded, onToggle, sortState, setSortState }) => (
  <CollapsibleTableSection
    title={`Transaction Analysis (${data.length} categories)`}
    expanded={expanded}
    onToggle={onToggle}
  >
    <div className="list-table-container">
      <table className="lox-hooktable-table table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
        <thead>
          <tr className="is-selected">
            {COLUMNS.map(({ column, label }) => (
              <SortableColumnHeader
                key={column}
                label={label}
                column={column}
                sortState={sortState}
                onSort={() => handleSort(setSortState, column)}
              />
            ))}
          </tr>
        </thead>
        <tbody>
          {sortData(data, sortState.column, sortState.direction).map((summary) => (
            <tr key={`analysis-${summary.category}`}>
              <td className="has-text-centered is-nowrap">{summary.category}</td>
              <td className="has-text-centered is-nowrap">{summary.totalCount}</td>
              <td className="has-text-centered is-nowrap">{CurrencyFormat({ value: summary.totalAmount })}</td>
              <td className="has-text-centered is-nowrap">{summary.recentCount}</td>
              <td className="has-text-centered is-nowrap">{CurrencyFormat({ value: summary.recentAmount })}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </CollapsibleTableSection>
)

export default TransactionAnalysisTable
